@if (!hideDefaultMessage()) {
  <div class="page">
    <div class="page__inner">
      <hrra-status-message
        variant="error"
        [heading]="'label.PageDoesNotExist' | translate"
        [message]="'<p>' + ('text.PageDoesNotExistFirstParagraph' | translate) + '</p><p>' + ('text.PageDoesNotExistSecondParagraph' | translate) + '</p>'"
        [actionLabel]="'label.ViewAllAnnouncements' | translate"
        (action)="onGoHome()"
      ></hrra-status-message>
    </div>
  </div>
}
